const viewPinPrefix = 'VIEW_PIN_ISSUING';

export const VIEW_PIN_START = `${viewPinPrefix}/VIEW_PIN_START`;
export const VIEW_PIN_SUCCESS = `${viewPinPrefix}/VIEW_PIN_SUCCESS`;
export const VIEW_PIN_FAIL = `${viewPinPrefix}/VIEW_PIN_FAIL`;

export const VIEW_PIN_SET_TIME_OUT = `${viewPinPrefix}/VIEW_PIN_SET_TIME_OUT`;
